<template>
  <b-container class="col-12">
    <ValidationObserver ref="observer2">
      <b-row>
        <b-col>
          <b>
            <label style="margin-bottom:-3px">Personal Information</label>
          </b>
          <br />
          <span class="add-info">
            <b>
              All lines marked with an asterisk (
              <font color="red">*</font> ) are required.
            </b>
          </span>
          <hr />
          <b-form-group
            label-cols-md="5"
            label="Title "
            class="mb-1"
            label-class="font-weight-bold pt-0 text-md-right text-sm-left"
          >
            <b-form-radio-group class="pt-2" :options="['Mr', 'Mrs', 'Miss']" v-model="form.title"></b-form-radio-group>
          </b-form-group>
          <b-form-group
            label-cols-sm="5"
            label="Name "
            label-for="name"
            label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
            class="mb-1"
          >
            <b-input-group class="mb-1" id="name">
              <validation-provider
                rules="required"
                :bails="false"
                v-slot="{ classes, errors }"
                name="First Name"
                class="col-sm-4 col-xs-12 p-0 pr-1"
                vid="fname"
              >
                <div class="control" :class="classes">
                  <b-form-input
                    type="text"
                    id="nested-fname"
                    placeholder="First Name"
                    v-model="form.MemberFname"
                    ref="fname"
                    class="customSmallInputGap"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                      rules="required"
                      v-slot="{ classes, errors }"
                      name="Last Name"
                      class="col-sm-4 col-xs-12 p-0 pr-1"
                      vid="lname"
              >
                <div class="control" :class="classes">
                  <b-form-input
                          id="nested-lname"
                          placeholder="Last Name"
                          v-model="form.MemberLname"
                          ref="lname"
                          class="customSmallInputGap"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                v-slot="{ classes, errors }"
                name="Middle Name"
                class="col-sm-4 col-xs-12 p-0 pr-1"
                vid="mname"
              >
                <div class="control" :class="classes">
                  <b-form-input
                    id="nested-minitial"
                    placeholder="Middle Name"
                    style="margin-right:3px"
                    v-model="form.MemberMname"
                    class="customSmallInputGap"
                    ref="mname"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label-cols-sm="5"
            label="Date of Birth "
            label-for="dob"
            label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
            class="mb-0"
          >
            <b-input-group class="mb-1" id="dob">
              <ValidationProvider
                rules="required|min-age"
                v-slot="{ classes, errors }"
                name="Date of Birth"
                class="p-0 col-12"
                vid="dob"
              >
                <div class="control" :class="classes">
                    <b-form-input
                        id="example-input"
                        v-model="form.dob"
                        type="date"
                        placeholder="MM/DD/YYYY"
                        autocomplete="off"
                        :max="maxDate"
                        class="mb-0 col-xs-8 col-sm-8 col-md-8 col-lg-4"
                    ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label-cols-sm="5"
            label="Gender "
            class="mb-1"
            label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
          >
            <div class="control">
              <b-form-radio-group
                      class="pt-2"
                      :options="{M:'Male',F: 'Female',O: 'Other'}"
                      v-model="form.memberGender"
                      ref="gender"
              ></b-form-radio-group>
            </div>
            <ValidationProvider
              rules="required"
              v-slot="{ classes, errors }"
              name="Gender"
              class="col-3 p-0"
              vid="gender"
            >
              <div class="control" :class="classes">
                <b-form-input v-model="form.memberGender" v-show="false"></b-form-input>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-sm="5"
            label="Home Phone Number "
            label-for="homephone"
            label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
            class="mb-2"
          >
            <ValidationProvider
              rules="required|min-phnum:10"
              v-slot="{ classes, errors }"
              name="Home Phone Number"
              class="col-md-3 p-0"
              vid="homephone"
            >
              <div class="control" :class="classes">
                <b-form-input
                  id="homephone"
                  ref="homephone"
                  placeholder="Home Phone Number"
                  class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                  v-model="form.homephone"
                  v-mask="'(###)-###-####'"
                ></b-form-input>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-sm="5"
            label="Alternate Phone Number "
            label-for="altphone"
            label-class="font-weight-bold pt-0 text-md-right text-sm-left"
            class="mb-2"
          >
            <ValidationProvider
              rules="min-phnum:10"
              v-slot="{ classes, errors }"
              name="Alternate Phone Number"
              class="col-3 p-0"
              vid="altphone"
            >
              <div class="control" :class="classes">
                <b-form-input
                  id="altphone"
                  ref="altphone"
                  placeholder="Alternate Phone Number"
                  class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                  v-model="form.altphone"
                  v-mask="'(###)-###-####'"
                ></b-form-input>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-sm="5"
            label="Email "
            label-for="email"
            label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
            class="mb-2"
          >
            <ValidationProvider
              rules="email|required"
              v-slot="{ classes, errors }"
              name="Email"
              class="col-3 p-0"
              vid="email"
            >
              <div class="control" :class="classes">
                <b-form-input id="email" class="col-xs-8 col-sm-8 col-md-8 col-lg-6" v-model="form.memberEmail" ref="email" placeholder="Email"></b-form-input>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-sm="5"
            label="Confirm Email "
            label-for="email"
            label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
            class="mb-2"
          >
            <ValidationProvider
              rules="email|required|confirmEmail:@email"
              v-slot="{classes, errors }"
              name="Confirmation Email"
              class="col-3 p-0"
              vid="cemail"
            >
              <div class="control" :class="classes">
                <b-form-input
                  id="cemail"
                  required
                  placeholder="Confirm Email"
                  class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                  v-model="form.memberConEmail"
                  ref="cemail"
                ></b-form-input>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <hr />
          <b-row>
            <b-col class="col-lg-6 col-md-12 col-sm-12 text-lg-right text-left right text-sm-left">
              <h6><b><font color="#212529"> Permanent Residence Address</font></b></h6>
              <br />
            </b-col>
          </b-row>
          <div :key="addrComponent">
            <b-form-group
                label-cols-sm="5"
                label="Street 1 "
                label-for="perResidence"
                label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
                class="mb-2"
            >
              <ValidationProvider
                  rules="required"
                  v-slot="{ classes, errors }"
                  name="Street 1"
                  class="col-3 p-0"
                  vid="praddr"
              >
                <div class="control" :class="classes">
                  <b-form-input
                      id="perResidence"
                      class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      ref="praddr"
                      placeholder="Street 1"
                      v-model="form.memberPerAddr"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="Street 2 "
                label-for="perResidence1"
                label-class="font-weight-bold pt-0 text-md-right text-sm-left"
                class="mb-2"
            >
              <ValidationProvider
                  v-slot="{ classes, errors }"
                  name="Street 2"
                  class="col-3 p-0"
                  vid="praddr2"
              >
                <div class="control" :class="classes">
                  <b-form-input
                      id="perResidence1"
                      class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      ref="praddr2"
                      v-model="form.memberPerAddr2"
                      placeholder="Street 2"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="Zip Code "
                label-for="perZip"
                label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
                class="mb-2"
            >
              <ValidationProvider
                  rules="required|zipCodValid"
                  v-slot="{ classes, errors }"
                  name="Zip Code"
                  class="col-3 p-0"
                  vid="przip"
              >
                <div class="control" :class="classes">
                  <b-form-input id="perZip" class="col-xs-8 col-sm-8 col-md-8 col-lg-6" ref="przip"
                                v-model="form.memberPerZip" @input="getZipDetails(form.memberPerZip,'personal')"
                                placeholder="Zip Code"
                                @blur="addrComponent += 1;"></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="City "
                label-for="perCity"
                label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
                class="mb-2"
            >
              <ValidationProvider
                  rules="required"
                  v-slot="{ classes, errors }"
                  name="City"
                  class="col-3 p-0"
                  vid="prcity"
              >
                <div class="control" :class="classes">
                  <b-form-input id="perCity" class="col-xs-8 col-sm-8 col-md-8 col-lg-6" ref="prcity"
                                placeholder="City"
                                v-model="form.memberPerCity" debounce="500" disabled></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="State "
                label-for="perState"
                label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
                class="mb-2"
            >
              <ValidationProvider
                  rules="required"
                  v-slot="{ classes, errors }"
                  name="State"
                  class="col-3 p-0"
                  vid="prstate"
              >
                <div class="control" :class="classes">
                  <b-form-input
                      id="input-1"
                      v-model="form.memberPerStateName"
                      class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      placeholder="State"
                      ref="prstate"
                      disabled
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="County "
                label-for="ResidentialCounty"
                label-class="font-weight-bold pt-0 custom-req text-md-right text-sm-left"
                class="mb-2"
            >
              <ValidationProvider
                  rules="required"
                  v-slot="{ classes, errors }"
                  name="County"
                  class="col-3 p-0"
                  vid="ResidentialCounty"
              >
                <div class="control" :class="classes">
                  <b-form-input id="ResidentialCounty" class="col-xs-8 col-sm-8 col-md-8 col-lg-6" ref="przip"
                                placeholder="County"
                                v-model="form.ResidentialCounty" disabled></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
          </div>
          <hr/>
          <b-row>
            <b-col class="col-lg-6 col-md-12 col-sm-12 text-lg-right text-left right text-sm-left">
              <h6><b><font color="#212529">Mailing Address (If different from your Permanent Address)</font></b></h6>
              <br/>
            </b-col>
          </b-row>
          <div :key="mailaddrComponent">
            <b-form-group
                label-cols-sm="5"
                label="Street 1 "
                label-for="mailAddr"
                label-class="font-weight-bold pt-0 text-md-right text-sm-left"
                class="mb-2"
            >
              <b-form-input id="mailAddr" class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                            placeholder="Street 1"
                            v-model="form.memberMailAddr"></b-form-input>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="Street 2 "
                label-for="mailCityMailing"
                label-class="font-weight-bold pt-0 text-md-right text-sm-left"
                class="mb-2"
            >
              <b-form-input id="mailCityMailing" class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                            placeholder="Street 2"
                            v-model="form.memberMailStreet"></b-form-input>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="Zip Code "
                label-for="mailZip"
                label-class="font-weight-bold pt-0 text-md-right text-sm-left"
                class="mb-2"
            >
              <ValidationProvider
                  rules="zipCodValid"
                  v-slot="{ classes, errors }"
                  name="Zip Code"
                  class="col-3 p-0"
                  vid="mailZip"
              >
                <div class="control" :class="classes">
                  <b-form-input id="mailZip" class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                                placeholder="Zip Code"
                                v-model="form.memberMailZip" @input="getZipDetails(form.memberMailZip,'mailing')"
                                @blur="mailaddrComponent += 1;"></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="City "
                label-for="mailCity"
                label-class="font-weight-bold pt-0 text-md-right text-sm-left"
                class="mb-2"
            >
              <b-form-input id="mailCity" class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                            placeholder="City"
                            v-model="form.memberMailCity" disabled></b-form-input>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="State "
                label-for="mailState"
                label-class="font-weight-bold pt-0 text-md-right text-sm-left"
                class="mb-2"
            >
              <b-form-input
                  id="mailState"
                  v-model="form.memberMailStateName"
                  placeholder="State"
                  class="col-xs-8 col-sm-8 col-md-8 col-lg-6" disabled
              ></b-form-input>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="County "
                label-for="MailingCounty"
                label-class="font-weight-bold pt-0 text-md-right text-sm-left"
                class="mb-2"
            >
              <ValidationProvider
                  v-slot="{ classes, errors }"
                  name="County"
                  class="col-3 p-0"
                  vid="MailingCounty"
              >
                <div class="control" :class="classes">
                  <b-form-input id="MailingCounty" class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                                placeholder="County"
                                v-model="form.MailingCounty" disabled></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
          </div>
          <hr />
        </b-col>
      </b-row>
    </ValidationObserver>
  </b-container>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import MedicareLeadsService from "../../MedicareLeadsService";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";

extend("confirmEmail", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Email confirmation does not match"
});
extend("min-phnum", {
  validate(value) {
    let phonenumberonly = value
      .replace(/\(/g, "")
      .replace(/\)/g, "")
      .replace(/-/g, "");
    return phonenumberonly.length == 10;
  },
  message: "{_field_} should always be 10 digits"
});
extend("min-age", {
  validate(value) {
    const now = new Date();
    let maxDateVal = new Date(now.getFullYear() - 65, 11, 31);
    return new Date(value) <= maxDateVal;
  },
  message: "Invalid DOB, enrollee's age must be 65 years or older."
});
export default {
  name: "PersonalInfoComponent",
  components: {
    ValidationProvider
  },
  data() {
    const now = new Date();
    let maxDateVal = new Date(now.getFullYear() - 65, now.getMonth(),now.getDate());
    let dd = maxDateVal.getDate();
    let mm = maxDateVal.getMonth()+1; //January is 0!
    let yyyy = maxDateVal.getFullYear();
    if(dd<10){
      dd='0'+dd
    }
    if(mm<10){
      mm='0'+mm
    }

    maxDateVal = yyyy+'-'+mm+'-'+dd;
    return {
      maxDate: maxDateVal,
      zipDetails: [],
      addrComponent: 0,
      mailaddrComponent: 10
    };
  }, methods: {
    async getZipDetails(val, addrType) {
      this.zipDetails = [];
      if (val && val.length > 4) {
        this.zipDetails = await MedicareLeadsService.getZipCodeDetails(val);
        if (this.zipDetails.length > 0) {
          if (addrType === 'personal'){
            this.form.memberPerCity = this.zipDetails[0].CityName.toLowerCase().charAt(0).toUpperCase() + this.zipDetails[0].CityName.toLowerCase().slice(1);
            this.form.memberPerStateName = this.zipDetails[0].StateName;
            this.form.memberPerState = this.zipDetails[0].StateAbbr;
            this.form.ResidentialCounty = this.zipDetails[0].CountyName ? this.zipDetails[0].CountyName.toLowerCase().charAt(0).toUpperCase() + this.zipDetails[0].CountyName.toLowerCase().slice(1) : '';
            this.addrComponent += 1;
          } else {
            this.form.memberMailCity = this.zipDetails[0].CityName.toLowerCase().charAt(0).toUpperCase() + this.zipDetails[0].CityName.toLowerCase().slice(1);
            this.form.memberMailStateName = this.zipDetails[0].StateName;
            this.form.memberMailState = this.zipDetails[0].StateAbbr;
            this.form.MailingCounty = this.zipDetails[0].CountyName ? this.zipDetails[0].CountyName.toLowerCase().charAt(0).toUpperCase() + this.zipDetails[0].CountyName.toLowerCase().slice(1) : '';
            this.mailaddrComponent +=1;
          }
        } else {
          if (addrType === 'personal') {
            this.form.memberPerCity = '';
            this.form.memberPerState = '';
            this.form.ResidentialCounty = '';
            //this.addrComponent += 1;
          } else {
            this.form.memberMailCity = '';
            this.form.memberMailState = '';
            this.form.MailingCounty = '';
            //this.mailaddrComponent +=1;
          }
        }
      }else {
        if (addrType === 'personal') {
          this.form.memberPerCity = '';
          this.form.memberPerState = '';
          this.form.memberPerStateName = '';
          this.form.ResidentialCounty = '';
          //this.addrComponent += 1;
        }else {
          this.form.memberMailCity = '';
          this.form.memberMailState = '';
          this.form.MailingCounty = '';
          //this.mailaddrComponent +=1;
        }
      }

    }
  },
  async created() {
    // try {
    //   //this.usstates = await MedicareLeadsService.getStates();
    // } catch (err) {
    //   this.error = err.message;
    // }
  },
  props: {
    form: Object
  }
};
</script>
<style scoped>
#PersonalInformation1 .col-form-label {
  /*text-align: right;*/
  top: 0.4em;
  padding-right: 1em;
}
</style>
